import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ord = (d) => `${d}${d % 10 === 1 && d !== 11 ? "st" : d % 10 === 2 && d !== 12 ? "nd" : d % 10 === 3 && d !== 13 ? "rd" : "th"}`;

const dayWord = (e) => {
  if (e.status === "OVERDUE") return `OVERDUE ${-e.days}d`;
  if (e.status === "DUE_TODAY") return "DUE TODAY";
  return `in ${e.days}d`;
};

export default function CadenceBar({ show }) {
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    axios.get(`${API}/cadence`).then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 120000);
    return () => clearInterval(t);
  }, [load]);

  if (!data) return null;
  const overdue = data.entries.filter((e) => e.status === "OVERDUE");
  const seen = new Set();
  const upcoming = data.entries.filter((e) => {
    if (!(e.status === "UPCOMING" || e.status === "DUE_TODAY") || seen.has(e.key)) return false;
    seen.add(e.key);
    return true;
  });
  const shown = [...overdue, ...upcoming];
  if (!shown.length) return null;

  return (
    <div className={`cad-bar no-print ${overdue.length ? "has-overdue" : ""}`} data-testid="cadence-bar">
      <div className="cad-head">
        <span className="cad-title">MONTHLY OPERATING CADENCE</span>
        <button className="cad-link" onClick={() => show("cad")} data-testid="cadence-bar-open">owners, history &amp; calendar invites →</button>
      </div>
      <div className="cad-strip">
        {shown.map((e) => (
          <button key={`${e.key}-${e.month}`} className={`cad-chip ${e.status.toLowerCase()}`} onClick={() => show(e.target)}
            data-testid={`cadence-chip-${e.key}-${e.month}`}
            title={`Due ${e.due} · period ${e.period}`}>
            <span className="cad-day">{ord(e.day)}</span>
            <span className="cad-item">{e.title}</span>
            <span className="cad-owner">{e.owner}</span>
            <span className={`cad-days ${e.status.toLowerCase()}`}>{dayWord(e)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
